/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AiChatSettingsDto } from '../models/AiChatSettingsDto';
import type { AiChatTokenDto } from '../models/AiChatTokenDto';
import type { DocumentationSearchRequestDto } from '../models/DocumentationSearchRequestDto';
import type { DocumentationSearchResponseDto } from '../models/DocumentationSearchResponseDto';
import type { PostAiChatHistoryDto } from '../models/PostAiChatHistoryDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AiChatService {

    /**
     * Save AI Chat history
     * @returns any Successfully saved chat history
     * @throws ApiError
     */
    public static postAiChatHistory({
        requestBody,
    }: {
        requestBody: PostAiChatHistoryDto,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ui/v1/ai-chat/chat-history',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Search Sifflet documentation using RAG
     * @returns DocumentationSearchResponseDto Successfully retrieved documentation
     * @throws ApiError
     */
    public static searchDocumentation({
        requestBody,
    }: {
        requestBody: DocumentationSearchRequestDto,
    }): CancelablePromise<DocumentationSearchResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ui/v1/ai-chat/search-documentation',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Fetch the value of AI chat settings
     * @returns AiChatSettingsDto Successfully fetched AI chat settings
     * @throws ApiError
     */
    public static getAiChatSettings(): CancelablePromise<AiChatSettingsDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ui/v1/ai-chat/settings',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Retrieve AI Chat token
     * @returns AiChatTokenDto Successfully retrieved AI Chat token
     * @throws ApiError
     */
    public static getAiChatAuthToken(): CancelablePromise<AiChatTokenDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ui/v1/ai-chat/token',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

}
